import React from 'react';
import { AiOutlineDisconnect } from 'react-icons/ai';

/** Absolute clock time with milliseconds: HH:MM:SS.mmm */
export function formatBuzzClock(timestamp) {
  const d = new Date(Number(timestamp) || 0);
  if (Number.isNaN(d.getTime())) return '—';

  const pad2 = (n) => String(n).padStart(2, '0');
  const pad3 = (n) => String(n).padStart(3, '0');

  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(
    d.getSeconds()
  )}.${pad3(d.getMilliseconds())}`;
}

export default function QueueList({
  buzzedPlayers,
  isHost = false,
  myId = null,
  onReset = null,
}) {
  return (
    <div
      className={`queue card-panel ${isHost ? 'queue-panel' : 'player-queue'}`}
    >
      <div className="queue-head">
        <p>Navbat</p>
        <span className="queue-head-hint">vaqt</span>
      </div>

      <ul>
        {buzzedPlayers.length === 0 ? (
          <li className="empty-queue">Hali ovoz yo‘q</li>
        ) : (
          buzzedPlayers.map(({ id, name, timestamp, connected }, i) => {
            const isMe = myId != null && id === myId;
            const isAnswering = i === 0;
            return (
              <li
                key={id}
                className={`${isAnswering ? 'head answering' : ''} ${
                  isHost ? 'resettable' : ''
                }`}
              >
                <div
                  className="player-sign queue-row"
                  onClick={() => {
                    if (isHost && onReset) onReset(id);
                  }}
                >
                  <div className={`name ${!connected ? 'dim' : ''}`}>
                    {isAnswering ? (
                      <span className="q-badge">Javob beradi</span>
                    ) : (
                      <span className="q-pos">{i + 1}.</span>
                    )}{' '}
                    {name}
                    {isMe ? <span className="you-inline"> siz</span> : null}
                    {!connected ? (
                      <AiOutlineDisconnect className="disconnected" />
                    ) : null}
                  </div>
                  <div
                    className={`buzz-time ${isAnswering ? 'first' : ''}`}
                    title={`Ovoz vaqti: ${formatBuzzClock(timestamp)}`}
                  >
                    {formatBuzzClock(timestamp)}
                  </div>
                </div>
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
}
